module.exports = __webpack_public_path__ + "static/how-right-1-bf1a92e722130769d0d22eff075a4ee5.jpg";